import { Component } from "react";
import TableNew, { CELL_TYPES } from "../../../shared/Table";
import { TableCellAccountRedirect } from "../../../shared/Table/components/Cell";
import RefreshButton from "../../../shared/ui/Refresh.Button";
import WithdrawTableButtons from "./table/WithdrawTableButtons";

import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import PropTypes from "prop-types";
import ClaimsWrapper from "../../../shared/ui/Claim.Wrapper";
import { allClaimsOtherThanAml } from "../../../shared/ClaimLists/Claim.Aml.All.List";
import { compose } from "redux";
import { borrowerOrdersConnector } from "../../../services/borrowerOrders/connector";

class LoanstepTableCellWithdrawalActions extends Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false,
      date: new Date(props.item.OrderDate),
      amount: props.item.Amount,
    };
  }

  handleOpen = () => {
    this.setState({
      open: true,
      date: new Date(this.props.item.OrderDate),
      amount: this.props.item.Amount,
    });
  };

  handleClose = () => {
    this.setState({
      open: false,
      date: this.state.date,
      amount: this.state.amount,
    });
  };

  handleConfirm = () => {
    this.props.approveWithdrawalOrder(this.props.item.Id);
    this.handleClose();
  };

  handleChangeDate = (event, date) => {
    this.setState({
      date: date,
      open: this.state.open,
      amount: this.state.amount,
    });
  };

  handleChangeAmount = (event, amount) => {
    this.setState({
      date: this.state.date,
      open: this.state.open,
      amount: amount,
    });
  };

  render() {
    const actions = [
      <Button
        variant="outlined"
        key="1"
        color="primary"
        onClick={this.handleConfirm}
      >
        Confirm
      </Button>,
      <Button variant="outlined" key="3" onClick={this.handleClose}>
        Close
      </Button>,
    ];
    return (
      <div className="table-cell-actions">
        <ClaimsWrapper claimAuth={allClaimsOtherThanAml}>
          <Button
            disabled={
              this.props.item.AmlWarning || this.props.item.AmlWarning === null
            }
            style={
              this.props.item.AmlWarning ? { backgroundColor: "#dec1c3" } : {}
            }
            variant="contained"
            color="primary"
            onClick={this.handleOpen}
          >
            Confirm
          </Button>
        </ClaimsWrapper>
        <Dialog modal={false} open={this.state.open}>
          <DialogTitle>Approve withdrawal order</DialogTitle>
          <DialogContent>
            Withdrawal Order Id <br />
            {this.props.item.Id}
            <br />
            Amount <br />
            <TextField
              size="small"
              variant="outlined"
              value={this.state.amount}
              onChange={this.handleChangeAmount}
              label="Amount"
            />
          </DialogContent>
          <DialogActions>{actions}</DialogActions>
        </Dialog>
      </div>
    );
  }
}

class LoanstepWithdrawalsComponent extends Component {
  constructor(props) {
    super(props);

    let columns = [
      {
        key: "BorrowerId",
        label: "BorrowerId",
        visible: true,
        type: CELL_TYPES.text,
        renderer: (value) => {
          return <TableCellAccountRedirect value={value} type={"accountId"} />;
        },
      },
      { key: "Id", label: "OrderId", visible: true, type: CELL_TYPES.text },
      { key: "Amount", label: "Amount", visible: true, type: CELL_TYPES.money },
      { key: "Notes", label: "Notes", visible: true, type: CELL_TYPES.text },
      { key: "BankAccountNumber", label: "Bank account", visible: true },
      { key: "BankAccountBank", label: "Bank", visible: true },
      {
        key: "Created",
        label: "Order date",
        visible: true,
        type: CELL_TYPES.date,
      },
      {
        key: "actions",
        label: "Actions",
        visible: true,
        renderer: (value, item) => {
          return (
            <LoanstepTableCellWithdrawalActions
              approveWithdrawalOrder={props.approveWithdrawalOrder}
              item={item}
              value={value}
            />
          );
        },
      },
    ];

    this.state = { columns, selectedIds: [] };
  }

  UNSAFE_componentWillMount() {
    if (
      this.props.orders.withdraw.data &&
      !this.props.orders.withdraw.data.length &&
      !this.props.orders.withdraw.fetching
    ) {
      this.props.fetchWithdrawalOrders();
    }
  }

  render() {
    return (
      <div className="deposit-layout body-height">
        <RefreshButton
          onRefreshClick={
            !this.props.orders.withdraw.fetching &&
            this.props.fetchWithdrawalOrders
          }
        />
        <h3>Pending withdrawal orders</h3>
        {this.props.orders.withdraw.fetched ? (
          <TableNew
            {...this.props}
            selectId={"Id"}
            columns={this.state.columns}
            items={this.props.orders.withdraw.data}
            actionColumnWidth={200}
            order="-OrderDate"
            tableKey="withdrawal_orders_loanstep"
            aboveContentRenderer={(getSelected, rows, props) => {
              return (
                <ClaimsWrapper claimAuth={allClaimsOtherThanAml}>
                  <WithdrawTableButtons
                    {...props}
                    approveWithdrawalOrders={this.props.approveWithdrawalOrders}
                    getSelected={getSelected}
                    rows={rows}
                  />
                </ClaimsWrapper>
              );
            }}
          />
        ) : (
          <div>Fetching data...</div>
        )}
      </div>
    );
  }

  static propTypes = {
    swapDeposits: PropTypes.func,
    fetchWithdrawalOrdersByAccount: PropTypes.func,
    fetchWithdrawalOrders: PropTypes.func,
    approveWithdrawalOrder: PropTypes.func,
    cancelWithdrawalOrder: PropTypes.func,
  };
}

export default compose(borrowerOrdersConnector)(LoanstepWithdrawalsComponent);
